import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { i18n } from "@/plugins/i18n";
import "./plugins/Auth";
import Vuelidate from "vuelidate";
import Vuetify from "vuetify";
import genericClass from "./helpers/generic.js";
import communicationsImage from "./components/communicationsImage.vue";
import communicationTable from "./components/communicationTable.vue";
import communication from "./components/communication.vue";
import JSZip from 'jszip'

Vue.use(Vuelidate);
Vue.use(JSZip);
Vue.component('communicationsImage', communicationsImage);
Vue.component('communicationTable', communicationTable);
Vue.component('communication', communication);

Vue.prototype.$apiRoot = process.env.VUE_APP_API_URL;
Vue.config.productionTip = false;
Vue.prototype.$genericClass = genericClass;

new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
}).$mount("#app");
